'use strict';

/* ── SURVEY (homepage only) ─── */
var _svo = document.getElementById('svo');
if(_svo){
  var D={r:'',oc:'',em:'',st:'',story:'',names:'',det:'',voice:'',email:''};
  var cur=1,tot=10;
  function openSurvey(e){if(e)e.preventDefault();_svo.classList.add('op');document.body.style.overflow='hidden';setTimeout(()=>{var el=document.getElementById('sn1');if(el)el.focus();},300)}
  function closeSurvey(){_svo.classList.remove('op');document.body.style.overflow='';}
  _svo.addEventListener('click',e=>{if(e.target===_svo)closeSurvey();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeSurvey();});
  function showStep(n){
    document.getElementById('svs'+cur).classList.remove('ac');
    cur=n;
    document.getElementById('svs'+n).classList.add('ac');
    document.getElementById('svsl').textContent='Step '+n+' of '+tot;
    document.getElementById('svpf').style.width=Math.round(n/tot*100)+'%';
    var bd=document.querySelector('.sv-bd');if(bd)bd.scrollTop=0;
  }
  function nx(s){
    document.querySelectorAll('.ferr').forEach(e=>e.classList.remove('show'));
    if(s===1){var v=document.getElementById('sn1').value.trim();if(!v){document.getElementById('e1').classList.add('show');return}D.r=v;document.getElementById('svnd').textContent=v.split(' ')[0]+'!';}
    else if(s===2){var b=document.querySelector('#sg2 .opb.sel');if(!b){document.getElementById('e2').classList.add('show');return}D.oc=b.dataset.v;}
    else if(s===3){var b=document.querySelector('#sg3 .opb.sel');if(!b){document.getElementById('e3').classList.add('show');return}D.em=b.dataset.v;}
    else if(s===4){var b=document.querySelector('#sg4 .opb.sel');if(!b){document.getElementById('e4').classList.add('show');return}D.st=b.dataset.v;}
    else if(s===5){var v=document.getElementById('sn5').value.trim();if(v.split(/\s+/).length<10){document.getElementById('e5').classList.add('show');return}D.story=v;}
    else if(s===6){var v=document.getElementById('sn6').value.trim();if(!v){document.getElementById('e6').classList.add('show');return}D.names=v;}
    else if(s===7){D.det=document.getElementById('sn7').value.trim();}
    else if(s===8){var b=document.querySelector('#sg8 .rdo.sel');if(!b){document.getElementById('e8').classList.add('show');return}D.voice=b.dataset.v;}
    else if(s===9){var v=document.getElementById('sn9').value.trim();if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){document.getElementById('e9').classList.add('show');return}D.email=v;}
    if(s<tot){showStep(s+1);}
    if(s===9){
      var ids=['rv1','rv2','rv3','rv4','rv5','rv6','rv7'];
      var vals=[D.r,D.oc,D.em,D.st,D.names,D.voice,D.email];
      ids.forEach((id,i)=>{var el=document.getElementById(id);if(el)el.textContent=vals[i]||'—';});
      showStep(10);
    }
  }
  function pv(s){showStep(s-1);}
  function selR(gid,el){document.querySelectorAll('#'+gid+' .rdo').forEach(r=>r.classList.remove('sel'));el.classList.add('sel');}
  document.querySelectorAll('.op-grid').forEach(g=>{g.addEventListener('click',e=>{var b=e.target.closest('.opb');if(!b)return;g.querySelectorAll('.opb').forEach(x=>x.classList.remove('sel'));b.classList.add('sel');});});
  function cc(inp,cnt,mx){var el=document.getElementById(inp);var cl=document.getElementById(cnt);if(el&&cl)cl.textContent=el.value.length+' / '+mx;}
  function finishSurvey(){
    var name=document.getElementById('sn1').value.trim();
    if(!name||!D.oc)return;
    var url=new URL('/pages/create-my-song',location.origin);
    url.searchParams.set('name',name);
    url.searchParams.set('occasion',D.oc);
    location.href=url.toString();
  }
}

/* ── MOBILE NAV (all pages) ─── */
var hbg=document.getElementById('hbg');
var mob=document.getElementById('mob');
if(hbg&&mob){
  hbg.addEventListener('click',function(e){
    e.stopPropagation();
    var o=mob.classList.toggle('open');
    hbg.setAttribute('aria-expanded',String(o));
    document.body.style.overflow=o?'hidden':'';
    // Change hamburger to X when open
    hbg.style.transform = o ? 'rotate(90deg)' : '';
  });
  // Close when any link inside mob is clicked
  mob.addEventListener('click',function(e){
    if(e.target.tagName==='A'){closeMob();}
  });
}
function closeMob(){
  if(mob)mob.classList.remove('open');
  if(hbg){hbg.setAttribute('aria-expanded','false');hbg.style.transform='';}
  document.body.style.overflow='';
}
document.addEventListener('click',function(e){
  if(mob&&mob.classList.contains('open')&&hbg&&!hbg.contains(e.target))closeMob();
});

/* ── STICKY CTA (all pages) ─── */
var stky=document.getElementById('stky');
var heroEl=document.querySelector('.hero');
var heroH=heroEl?heroEl.offsetHeight-100:500;
window.addEventListener('scroll',function(){
  if(stky)stky.classList.toggle('on',window.scrollY>heroH);
},{passive:true});

/* ── FAQ (all pages) ─── */
var faqEl=document.getElementById('faqList');
if(faqEl){
  faqEl.addEventListener('click',function(e){
    var q=e.target.closest('.fq');if(!q)return;
    var item=q.parentElement,open=item.classList.contains('open');
    document.querySelectorAll('.faq-item,.fi').forEach(function(i){i.classList.remove('open');});
    if(!open)item.classList.add('open');
  });
}

/* ── AUDIO TOGGLE (homepage) ─── */
var _heroAu=document.getElementById('heroAudio');
var _hPlay=false;
function toggleAudio(){
  var pi=document.getElementById('pi'),eq=document.getElementById('eq');
  if(!_heroAu)return;
  _hPlay?_heroAu.pause():_heroAu.play();_hPlay=!_hPlay;
  if(pi)pi.style.display=_hPlay?'none':'';
  if(eq)eq.style.display=_hPlay?'flex':'none';
}
if(_heroAu){_heroAu.addEventListener('ended',function(){_hPlay=false;var pi=document.getElementById('pi'),eq=document.getElementById('eq');if(pi)pi.style.display='';if(eq)eq.style.display='none';});}

/* ── SCROLL ANIMATIONS (all pages) ─── */
if('IntersectionObserver' in window){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('iv');io.unobserve(e.target);}});},{threshold:.08,rootMargin:'0px 0px -30px 0px'});
  document.querySelectorAll('.fu').forEach(function(el){io.observe(el);});
}else{document.querySelectorAll('.fu').forEach(function(el){el.classList.add('iv');});}
